import { LabelProps } from "./Label.types";
import { useClassNames } from "../../../structure";

export default function Label({ color, children, type = "l2Regular", classNames = [] }: LabelProps) {
  const style = useClassNames([type, ...classNames]);

  return (
    <label style={{ ...style, boxSizing: "border-box", ...(color ? { color } : {}), cursor: "inherit" }}>
      {children}
    </label>
  );
}
